import get from 'lodash/get'

export const isFetching = (state, fetching) => {
  const data = get(state, 'isFetching.isFetching')

  return data.includes(fetching)
}
